import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React from 'react'
import { ListOfProperty } from '@s4l/stayforlong/property/ListOfProperty'
import { useS4LContext } from '@s4l/react-context'
import { Typography } from '@s4l/ds'

import { PropertiesCarousel, PropertyCard } from '../../index'

import styles from './styles.module.css'

export interface IRelatedPropertiesProps {
  relatedPropertiesJSON: ReturnType<ListOfProperty['toJSON']> | undefined
  loading?: boolean
  onClickCTA?: (id: string, position: number) => void
}

function RelatedProperties({
  relatedPropertiesJSON,
  loading = false,
  onClickCTA,
}: Readonly<IRelatedPropertiesProps>) {
  const { i18n } = useS4LContext()

  if (loading) {
    return (
      <div className={styles.related} data-testid="related">
        <Typography as="h5" variant="title" size="xs" ellipsis>
          {i18n.formatMessage({ id: 'related.title' })}
        </Typography>
        <PropertiesCarousel.Placeholder itemsPerPage={[1.25, 2, 3]} />
      </div>
    )
  }

  if (!relatedPropertiesJSON) return null

  const relatedProperties = ListOfProperty.fromJSONOrEmpty({ json: relatedPropertiesJSON })

  if (relatedProperties.isEmpty()) return null

  return (
    <div className={styles.related} data-testid="related">
      <Typography as="h5" variant="title" size="xs" ellipsis>
        {i18n.formatMessage({ id: 'related.title' })}
      </Typography>

      <PropertiesCarousel propertiesJSON={relatedProperties.toJSON()} itemsPerPage={[1.25, 2, 3]}>
        {(property, index) => (
          <>
            <PropertyCard.FooterPrice />
            <PropertyCard.FooterCTA
              onClick={() => {
                if (onClickCTA) {
                  onClickCTA(property.id, index + 1)
                }
              }}
            />
          </>
        )}
      </PropertiesCarousel>
    </div>
  )
}

RelatedProperties.displayName = 'RelatedProperties'
export default withErrorBoundary(RelatedProperties)
